export const AUTO_INVENTORY_REPLENISHMENT_VI = {
  autoInventoryRepl: 'Tự động bổ sung hàng tồn kho',
  numberSellDays: 'Số ngày bán hàng tự động bổ sung hàng tồn',
  coverDay: 'Số ngày bán hàng',
}
